<template>
    
    <div class="nd-layout_container nd-layout_normal nd-layout_box apply_content ServiceTerm">

        <div class="help">
            <h1>网站条款、条件及声明</h1>
            <p>最后修订日期：2017 年 12 月 01 日</p>
            <p>凡通过任何方式访问或使用本网站的，您同意接受载于下文的所有条款及其条件。如果您不能接受这些条款和条件的，请不要使用本网站。我们保留在任何时候由我们自行判断改变或修改本网站协议的权利，恕不另行通知，而您的继续访问或使用本网站则表示您接受这些更新或修改的协议。
            </p>
            <p>以下提及这个“网站”是指<a href="http://www.etxing.com" target="_blank"
                    style="color: #669933;">www.etxing.com</a>及其任何一页。</p>
            <ul>
                <li>
                    <div class="help-title">
                        <h3>1. 价格</h3>
                    </div>
                    <p class="text_info">您认可，某些国家/地区的税务机关可能会征收特定的附加税（例如旅游税），此类税费须在当地缴纳。缴纳此类附加税的义务由您单方面承担。</p>
                    <p class="text_info">
                        您认可，除下文所述的服务款项产生的税款外，我们不会为相关税务机关代收税款。在适当情况下，酒店供应商会针对特定费用及税额（如果适用）向我们开具发票。酒店提供商将相应的税款缴至相应的税务管辖机关。我们向您收取的预付费酒店交易代收税款是指我们就客房出租所产生的税金而向酒店提供商支付的预计税额（例如，销售税和使用税、占用税、房屋税、消费税、增值税等）。而不是由我们向您收取并缴至相应税务机关的税款。我们向酒店供应商支付的实际税额可能
                        会因为追征税款金额的不同而异，具体取决于我们的客户实际入住酒店时有效的税率、可征税性等。我们保留服务费，作为向您提供旅行预订服务的报酬。我们的服务费随酒店预订金额和类型的不同而异。</p>
                    <p class="text_info">对于我们向其预订我们客户旅行安排的供应商，壹同行并非其联合供应商。可征税性与相应的税率因地区不同有很大差异。</p>
                    <p class="text_info">
                        销售税、入住税和/或当地酒店占用税将根据我们在特定辖区内提供服务所收取的费用（设施费和/或服务费）进行征收。例如，在纽约州（不包括纽约市）入住酒店时，上文所说的追征税款应包含酒店收到的客房租金产生的税款，而不包括我们提供服务所产生的当地酒店占用税。我们提供服务的实际税额可能因您入住酒店时的有效税率而异。
                    </p>
                </li>
                <li>
                    <div class="help-title">
                        <h3>2. 预付酒店的预订</h3>
                    </div>
                    <p class="text_info">我们保留可更改网站上显示价格的权利恕不另行通知。</p>
                    <p class="text_info">即使我们已经确认了您的预订并接受了您的付款，我们仍保留取消及返还您付款的权利。</p>
                    <p class="text_info">您可以取消或更改您预付酒店的预订，但您需支付由酒店征收的取消或变更费用。在高峰旺季，大多数酒店不允许取消和变更，已预订的房间和预付的款项均不予退换或返还。
                    </p>
                    <p class="text_info">即使我们确认了您的预订并接受了您预订的支付款项，酒店仍有有可能因超售而导致没有您需要的房间。如遇此类情况，该酒店有权利换给你一个同级别的酒店让您入住。</p>
                    <p class="text_info">我们尽量避免上述情况发生，但不能保证，一旦发生类似情况，我们将协助酒店为您安排替代性住宿。</p>
                    <p class="text_info">您不可在同一家酒店/同一入住日期在线预订 5 间以上客房。如果我们确认您分次预订了共计 5
                        间以上的客房，则可以取消您的预订，并向您收取取消费（如果适用）。如果您缴纳了不可退回的押金，您的押金将会被没收。</p>
                    <p class="text_info">所有对房间的要求均视酒店登记签到时房间的情况而定，我们并不能保证，除非以书面形式明确提到。</p>
                    <p class="text_info">您同意遵守您预付预订酒店的有关条款。</p>
                    <p class="text_info">在任何情况下，我们的赔偿或退款不会超出您支付给<a href="http://www.etxing.com" target="_blank"
                            style="color: #669933;">www.etxing.com</a>或者是酒店的费用。</p>
                </li>
                <li>
                    <div class="help-title">
                        <h3>3. 免责声明</h3>
                    </div>
                    <p class="text_info">本网站所提供的信息和服务可能包含不正确或错误的地方，包括定价的误差。
                        壹同行及其合作伙伴并不保证网站的准确性，并对本网站任何的错误或其他不正确之处不承担任何责任。</p>
                    <p class="text_info">
                        我们有权更改网站上的错误之处或/并修改正在处理中的错误报价预订。在这种情况下，如果可能的话，我们将尽可能以正确的价格保留您正在处理中的预订或者我们将取消您的预订而无任何罚款。</p>
                    <p class="text_info">显示在该网页上的酒店价格只是一般指引价格，我们不确保价格的完全准确性。</p>
                    <p class="text_info">壹同行及其各个供应商不确保一直有这些具体产品及服务。任何请求视情况而定，除非由供应商书面写的保证除外。</p>
                    <p class="text_info">
                        壹同行对于延迟、取消、超售、罢工、不可抗力超等超出其直接控制力的原因不付任何责任及退款，而对于当地政府或当局造成的额外费用、遗漏、延迟以及重新安排路线或活动也不承担任何责任。</p>
                    <p class="text_info">在任何情况下，壹同行的对于使用其网站服务而造成的直接、间接、惩罚性的、意外、特殊情况以及从属等损害皆不负责。</p>
                    <p class="text_info">尽管上述限制，一旦壹同行对于购买其网站上的产品或服务而造成的损失或损害承担赔偿责任，则壹同行赔偿或退款不会超出您支付给壹同行的服务费、酒店费。</p>
                </li>
            </ul>
        </div>
       

    </div> 
</template>

<script>

export default {
  name: 'CooperativeAgreement',
  data(){
    return{

    }
    
  },
  mounted() {

    document.title = this.$route.meta.title;
  }


}
</script>
<style scoped>

.term_content {
        margin-top: 20px;
  padding-top: 20px;
}

.help h1 {
    font-size: 35px;
    text-align: center;
    padding-bottom: 20px;
    font-weight: 400;
}

.help p {
    font-size: 15px;
}

.help-title {
    border-bottom: 1px solid #D2D2D2;
    padding: 20px 0;
    position: relative;
}

.help-title h3 {
    color: #333333;
    font-size: 20px;
    font-weight: 400;
}

.text_info {
    margin-top: 10px;
}

</style>
    